import { apiClient } from "../apiClient"

export const NAM_HOC_RESOURCE = "nam-hoc"
export const namHocApi = {
    SelectAll: () => apiClient.get(`${NAM_HOC_RESOURCE}`)
}